import { render, staticRenderFns } from "./welcome-tcr.vue?vue&type=template&id=4e7e5766&scoped=true&"
import script from "./welcome-tcr.vue?vue&type=script&lang=js&"
export * from "./welcome-tcr.vue?vue&type=script&lang=js&"
import style0 from "./welcome-tcr.vue?vue&type=style&index=0&id=4e7e5766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e5766",
  null
  
)

export default component.exports